import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomCopyButton from "../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { severities } from "../../environment/icons/iconExport";

const PowerShellCommand = ({
  command,
  label = "Run in PowerShell as Administrator",
  infoText,
}) => {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1} paddingLeft={2}>
      <Box
        sx={{
          position: "relative",
          width: "fit-content",
          marginTop: "8px",
        }}
        display="flex"
        flexDirection="column"
        gap={1}
      >
        <Typography
          sx={{
            position: "absolute",
            top: "-8px",
            left: "12px",
            fontSize: 12,
            color: colors.text_secondary,
            backgroundColor: colors.text_area_outlined_enabled_value_bg,
            paddingX: "4px",
            zIndex: 1,
          }}
        >
          {label}
        </Typography>
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Box
            sx={{
              border: `1px solid ${colors.text_area_outlined_enabled_stroke}`,
              backgroundColor: colors.text_area_outlined_enabled_value_bg,
              borderRadius: "8px",
              width: "600px",
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                height: "0px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: colors.grey_30percent,
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: colors.grey_50percent,
              },
            }}
          >
            <Typography
              color={colors.text_primary}
              sx={{
                // TODO: uncomment this when we have the font
                // fontFamily: "DM Mono",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "22px",
                padding: "16px 24px 16px 14px",
                whiteSpace: "nowrap",
                display: "block",
              }}
            >
              {command}
            </Typography>
          </Box>
          <Box>
            <CustomCopyButton
              copyTitle="command"
              copyText={command}
              width="18px"
              label="Copy"
              iconColor={colors.button_text_primary_enabled_text}
              labelColor={colors.button_text_primary_enabled_text}
            />
          </Box>
        </Box>
        {infoText && (
          <Box display="flex" flexDirection="row" gap={0.5}>
            <SvgToIcon
              IconLogo={severities.SeverityInfoTooltipIcon}
              style={{
                width: "16px",
                height: "16px",
                marginLeft: "16px",
              }}
            />
            <Typography variant={"caption"} color={colors.text_secondary}>
              {infoText}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PowerShellCommand;
